const NameWrapper = (props) => {
    const firstName = props.value.firstName;
    const lastName = props.value.lastName;

    return <span>{firstName} {lastName}</span>
  };
  
  export default NameWrapper;
  